/* 4kaad ES — Carrusel de reseñas reutilizable (home + PDP).
   - Flechas prev/next que desplazan por el ancho de una tarjeta.
   - Arrastre táctil / con puntero (pointer events) sobre el track.
   - Habilita/deshabilita las flechas según la posición de scroll.
   Se aplica a cualquier raíz con [data-track] (pista) y [data-nav] (flechas). */
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var nav = root.querySelector('[data-nav]');
    var prev = nav ? nav.querySelector('[data-dir="-1"]') : null;
    var next = nav ? nav.querySelector('[data-dir="1"]') : null;

    function step() {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth * 0.9;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      var x = track.scrollLeft;
      prev.disabled = x <= 1;
      next.disabled = x >= max;
      var overflow = track.scrollWidth > track.clientWidth + 2;
      if (nav) nav.style.display = overflow ? '' : 'none';
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dir]');
        if (!btn) return;
        track.scrollBy({ left: parseInt(btn.dataset.dir, 10) * step(), behavior: 'smooth' });
      });
    }

    // Arrastre con puntero (ratón + táctil vía pointer events).
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function endDrag() { down = false; }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    // Evita que un arrastre dispare el click de un enlace-tarjeta.
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  window.Rev4kaadCarousel = initCarousel;

  // Auto-init de cualquier carrusel presente al cargar (por si el inline no corrió).
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-rev-carousel]').forEach(function (el) {
      if (!el.dataset.revInit) { el.dataset.revInit = '1'; initCarousel(el); }
    });
  });
})();
